<div class="repeatable-process">
    <div (click)="isToggle = !isToggle" class="head">
        Restart the process (optional)
        <i class="fa"
           [class.fa-caret-down]="isToggle"
           [class.fa-caret-up]="!isToggle"></i>
    </div>
    <div class="parent-terms" [collapse]="isToggle">
        <div *ngFor="let process of processes" class="terms p-b-20">
            <div class="caption">
                Launch date:<br />
                <input type="text" #launchDate="bsDatepicker" placeholder="" bsDatepicker>
                <i (click)="launchDate.toggle()" class="fa fa-calendar"></i>
            </div>
            <div class="caption">
                Expiration date:<br />
                <input type="text" #expirationDate="bsDatepicker" name="name" placeholder="" bsDatepicker />
                <i (click)="expirationDate.toggle()" class="fa fa-calendar"></i>
            </div>
            <div class="caption">
                Days for PM:<br />
                <input class="project-code" type="number" min="0">
            </div>
            <div class="caption">
                Days for HR:<br />
                <input class="project-code" type="number" min="0">
            </div>
            <div (click)="delete(process)" class="delete-process">
                <i class="mdi mdi-close"></i>
            </div>
        </div>
        <div class="d-flex align-items-center">
            <span (click)="push(process)" class="add-btn">
            </span>
            <span class="lh-1-1 m-l-10">
                Add a duplicate<br />
                launch
            </span>
        </div>
    </div>
</div>



